import React, { Fragment, ReactNode, useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";

interface CommonModalProps {
  children?: ReactNode;
  setopen: (value: boolean) => void;
  open: boolean;
  className?: string;
  title?: string;
  onSubmit?: (...args: any[]) => any;
  onCancel?: () => void;
  style?: React.CSSProperties;
  submit?: string;
  cancel?: string;
  submitting?: boolean;
  submittingText?: string;
}

const CommonModal: React.FC<CommonModalProps> = ({
  children,
  setopen,
  open,
  className,
  title = "add data",
  onSubmit,
  submit = "submit",
  cancel = "cancel",
  onCancel,
  style,
  submitting,
  submittingText,
}) => {
  const [open1, setopen1] = useState(true);

  const onclick = () => {
    setopen1(false);
    setTimeout(() => {
      setopen(false);
    }, 300);
    onCancel?.();
  };

  useEffect(() => {
    if (!open) {
      setopen1(false);
    } else {
      setopen1(true);
    }
  }, [open]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await onSubmit?.(e);
  };

  if (!open) return null;

  return (
    <Fragment>
      <div
        className={`fixed inset-x-0 bottom-0 top-[68px] z-[3] bg-erp-navy/35 backdrop-blur-[2px] transition-opacity duration-200 ${
          open1 ? "opacity-100" : "opacity-0"
        }`}
        onClick={onclick}
        aria-hidden
      />
      <div
        className={`fixed bottom-0 right-0 top-[68px] z-[4] flex w-full max-w-[720px] flex-col overflow-hidden border-l border-erp-line bg-white shadow-[-12px_0_40px_rgba(11,28,44,0.14)] transition-transform duration-300 ease-out ${className || ""}`}
        style={{
          transform: `translateX(${open1 ? 0 : 40}px)`,
          opacity: open1 ? 1 : 0,
          ...style,
        }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="relative flex shrink-0 items-center justify-between border-b border-erp-line bg-gradient-to-r from-white via-white to-erp-surface/60 px-4 py-3 pl-4">
          <div
            aria-hidden
            className="absolute inset-y-0 left-0 w-[3px] bg-gradient-to-b from-erp-gold via-erp-accent to-erp-navy"
          />
          <div className="min-w-0 pl-1.5">
            <p className="m-0 text-[10px] font-semibold uppercase tracking-[0.14em] text-erp-muted">
              Form
            </p>
            <h3 className="m-0 mt-0.5 truncate text-[15px] font-semibold capitalize leading-none tracking-[-0.01em] text-erp-ink">
              {title}
            </h3>
          </div>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onclick();
            }}
            className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-erp-line bg-white text-erp-muted transition-colors hover:border-erp-accent/40 hover:bg-erp-surface hover:text-erp-ink"
            aria-label="Close"
          >
            <ClearIcon sx={{ fontSize: 18 }} />
          </button>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto bg-erp-surface/30 px-4 py-3">
          <form action="" onSubmit={handleSubmit} className="font-inter">
            {children}
            <div className="sticky bottom-0 -mx-4 mt-4 flex items-center justify-end gap-2 border-t border-erp-line bg-white/95 px-4 py-3 backdrop-blur-[2px]">
              <button
                type="button"
                onClick={onclick}
                className="inline-flex h-8 min-w-[88px] items-center justify-center rounded-md border border-erp-line bg-white px-3 text-[12px] font-semibold capitalize text-erp-muted transition-colors hover:bg-erp-surface hover:text-erp-ink"
              >
                {cancel}
              </button>
              <button
                type="submit"
                disabled={submitting}
                className="inline-flex h-8 min-w-[96px] items-center justify-center rounded-md border-0 bg-[linear-gradient(90deg,#0b1c2c,#123048)] px-3 text-[12px] font-semibold capitalize text-white shadow-[0_2px_6px_rgba(11,28,44,0.16)] transition-[filter] hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {submitting ? submittingText || submit : submit}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default CommonModal;
